export default __webpack_public_path__ + "static/media/instagram.0fea5824.svg";